import React from 'react';

export default function Terms() {
  return (
    <div className="bg-gray-warm min-h-screen py-20 px-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <h1 className="text-4xl font-bold text-charcoal">Terms of Service</h1>
        <p className="text-gray-600">
          Use of our website constitutes agreement to receive the communications described on the contact form. We reserve the right to change services with notice.
        </p>
        <p className="text-gray-600">
          All strategies are advisory recommendations. Clients should consult their CPA before implementing any tax change.
        </p>
      </div>
    </div>
  );
}
